import { render, staticRenderFns } from "./ComponentIBExposureChart.vue?vue&type=template&id=f33991f6&scoped=true"
import script from "./ComponentIBExposureChart.vue?vue&type=script&lang=js"
export * from "./ComponentIBExposureChart.vue?vue&type=script&lang=js"
import style0 from "./ComponentIBExposureChart.vue?vue&type=style&index=0&id=f33991f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33991f6",
  null
  
)

export default component.exports